import React from 'react';
import { FormInstance } from 'antd';
import { TextArea, Form, Input } from '@common/components';
import { createMessage } from 'works/legacy/lib/message-helper';
import { FullValidationErrorFragmentType } from '@common/graphql/fragments';

type UnitShiftGapTagFormProps = {
  form: FormInstance;
  onFinish: (values: { name: string; description?: string }) => void;
};

export function UnitShiftGapTagForm({
  form,
  onFinish,
}: UnitShiftGapTagFormProps) {
  return (
    <Form form={form} layout="vertical" preserve={false} onFinish={onFinish}>
      <Form.Item
        name="name"
        label="Name"
        rules={[
          { required: true, message: 'Name is required' },
          { max: 30, message: 'Name must be 30 characters or less' },
        ]}
      >
        <Input placeholder="Enter tag name" maxLength={30} />
      </Form.Item>
      <Form.Item name="description" label="Description">
        <TextArea placeholder="Enter description (optional)" maxLength={120} />
      </Form.Item>
    </Form>
  );
}

export function unitShiftGapTagFormNameErrorsHandler(
  form: FormInstance,
  errors: FullValidationErrorFragmentType[]
) {
  const nameErrors = errors
    .filter((e) => e.attribute === 'name')
    .flatMap((e) => e.fullErrors);

  if (nameErrors.length) {
    form.setFields([{ name: 'name', errors: nameErrors }]);
    return;
  }

  const otherErrors = errors
    .filter((e) => e.attribute !== 'name')
    .flatMap((e) => e.fullErrors);

  if (otherErrors.length) {
    createMessage('error', otherErrors.join(', '));
  }
}
